export default "__VITE_ASSET__C1YVXc1$__"